<template>
  <div class="fs-main-wrapper" @click.passive="menuGoBack">
    <div class="fs-header">
      <router-view name="topBar" class="fs-top-bar"/>
      <router-view name="topMenu" class="fs-menu fs-menu-top" />
    </div>
    <div class="fs-content">
      <toast />
      <Canvas v-if="!isAppBlocked" />
      <div v-if="isAppBlocked" class="fs-canvas-blocked-pladeholder">
        <p>{{$t('messages.app_blocked.m1')}} <br /><br /> {{$t('messages.app_blocked.m2')}} <a href="https://www.filestack.com/contact/">filestack.com/contact/</a></p>
      </div>
      <div class="fs-footer">
        <router-view name="bottomMenu" class="fs-menu fs-bottom-menu"/>
        <div class="fs-bottom-bar"><router-view name="bottomBar" /></div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';

import Canvas from './Canvas.vue';
import Toast from './Toast.vue';
import { FsCanvas } from '@filestack/canvas-sdk';
import { Getter } from 'vuex-class';

@Component({
  components: { Canvas, Toast },
})
class Main extends Vue {

  @Inject('canvas')
  public canvas: FsCanvas;

  protected showOverlay: boolean = false;

  @Getter('isBlocked')
  protected isAppBlocked: boolean;

  protected menuGoBack($e: any) {
    if (document.body.contains(document.querySelector('.fs-menu.fs-bottom-menu')) &&
     this.$router.currentRoute.path !== '/' &&
     !$e.target.closest('a') &&
     !$e.target.closest('.fs-footer') &&
     !$e.target.closest('canvas')) {
      this.$router.push('/');
    }
  }
}

export default Main;
</script>
